import { authentication, createDirectus, rest } from '@directus/sdk';
import { apiUrl } from './config';

const directus = createDirectus<any>(apiUrl)
  .with(authentication('cookie', { credentials: 'include' }))
  .with(rest({ credentials: 'include' }));

export { directus };
